
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';
import { HomeTemplate } from '@/components/templates';

export default defineComponent({
  name: 'Component',
  components: { HomeTemplate },
  methods: {
    ...mapActions(['index']),
  },
  beforeMount() {
    this.index();
  },
});
